import { render, staticRenderFns } from "./d-program-preview.vue?vue&type=template&id=65323211&lang=pug&"
import script from "./d-program-preview.vue?vue&type=script&lang=js&"
export * from "./d-program-preview.vue?vue&type=script&lang=js&"
import style0 from "./d-program-preview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65323211')) {
      api.createRecord('65323211', component.options)
    } else {
      api.reload('65323211', component.options)
    }
    module.hot.accept("./d-program-preview.vue?vue&type=template&id=65323211&lang=pug&", function () {
      api.rerender('65323211', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/displays/d-program-preview.vue"
export default component.exports